module.exports = __webpack_public_path__ + "img/rocket.604ea167.svg";